import { useState } from "react";
import { Alert, Button } from "@mui/material";
import { useLocation } from "react-router";
import i18n from "@/i18n";
import { useTranslation } from "react-i18next";

const CRASH_TEST_QUERY_PARAM = "externalRegisterImportCrashTest";

export const isExternalRegisterImportCrashTestVisible = ({
  search,
  dev = import.meta.env.DEV,
  mode = import.meta.env.MODE,
}: {
  search: string;
  dev?: boolean;
  mode?: string;
}): boolean => {
  return (dev || mode === "test") && new URLSearchParams(search).get(CRASH_TEST_QUERY_PARAM) === "1";
};

export const ExternalRegisterImportCrashTestButton = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const [shouldCrash, setShouldCrash] = useState(false);

  if (shouldCrash) {
    throw new Error(i18n.t("externalRegister.import.diagnostics.errorMessage"));
  }

  if (!isExternalRegisterImportCrashTestVisible({ search: location.search })) {
    return null;
  }

  return (
    <Alert
      severity="warning"
      variant="outlined"
      action={(
        <Button color="warning" size="small" onClick={() => setShouldCrash(true)}>
          {t("externalRegister.import.diagnostics.button")}
        </Button>
      )}
    >
      {t("externalRegister.import.diagnostics.alert")}
    </Alert>
  );
};
